import Impressum from "./Impressum";

export default Impressum;
